module.exports = __webpack_public_path__ + "static/dripping_acrylic-and-oil-pen-on-canvas-paper_23.4x33in-679547423f09643b3577cf0e72e38ecc.jpeg";